import StockingBatchesContainer from './stocking-batches-container';

export default StockingBatchesContainer;
